import ApplicationController from './application_controller'

export default class extends ApplicationController
  @targets: ['image']

  # Switch the tutor in the carousel
  switchTutor: (event) ->
    $(@imageTargets).filter(':visible').fadeOut 200, =>
      $(@imageTargets).eq($(event.target).data('index')).fadeIn 800
